module.exports = __webpack_public_path__ + "static/media/Local.eaee429c.svg";